module.exports = [
  "backend.config",
  "DS",
  "$sce",
  function(backend, DS, $sce) {
    var summary = DS.defineResource({
      name: "leaveSummary",
      omit: [/^[$]/],
      idAttribute: "id",
      useClass: false,
      beforeInject: function(config, attrs) {
        if (Array.isArray(attrs)) {
          var beforeInject = summary.beforeInject.bind(this, config);
          attrs.forEach(beforeInject);
        } else {
          Object.assign(attrs, config.attrs);
        }
        return attrs;
      },
      computed: {
        $daysAvailable: [
          "employeeTotalHolidayDays",
          "employeeTotalPtoDays",
          "employeeTotalSickDays",
          "employeeTotalVacationDays",
          "employeeUsedHolidayDays",
          "employeeUsedPtoDays",
          "employeeUsedSickDays",
          "employeeUsedVacationDays",
          function(
            employeeTotalHolidayDays,
            employeeTotalPtoDays,
            employeeTotalSickDays,
            employeeTotalVacationDays,
            employeeUsedHolidayDays,
            employeeUsedPtoDays,
            employeeUsedSickDays,
            employeeUsedVacationDays
          ) {
            return (
              employeeTotalHolidayDays +
              employeeTotalPtoDays +
              employeeTotalSickDays +
              employeeTotalVacationDays -
              (employeeUsedHolidayDays +
                employeeUsedPtoDays +
                employeeUsedSickDays +
                employeeUsedVacationDays)
            );
          }
        ],
        $daysUsed: [
          "employeeUsedHolidayDays",
          "employeeUsedPtoDays",
          "employeeUsedSickDays",
          "employeeUsedVacationDays",
          function(
            employeeUsedHolidayDays,
            employeeUsedPtoDays,
            employeeUsedSickDays,
            employeeUsedVacationDays
          ) {
            return (
              employeeUsedHolidayDays +
              employeeUsedPtoDays +
              employeeUsedSickDays +
              employeeUsedVacationDays
            );
          }
        ]
      }
    });
    summary.find.before(function(id, opts = {}) {
      opts.endpoint = "/leave/" + backend.enterprise.code;
      opts.attrs = {
        id: id
      };
      return [id, opts];
    });
    summary.bindCurrent = function($scope, name) {
      return summary.bindOne(backend.userdata.email, $scope, name);
    };

    var requests = DS.defineResource({
      name: "leaveRequests",
      omit: [/^[$]/],
      idAttribute: "id",
      useClass: false,
      beforeInject: function(config, attrs) {
        if (Array.isArray(attrs)) {
          var beforeInject = summary.beforeInject.bind(this, config);
          attrs.forEach(beforeInject);
        } else {
          Object.assign(attrs, config.attrs);
        }
        return attrs;
      },
      computed: {
        $type: [
          "type",
          function(type) {
            return type[0] + type.slice(1).toLowerCase();
          }
        ],
        $status: [
          "status",
          function(type) {
            return type[0] + type.slice(1).toLowerCase();
          }
        ],
        $duration: [
          "duration",
          function(duration) {
            if (duration == 1) {
              return `${duration} Day`;
            } else {
              return `${duration} Days`;
            }
          }
        ],
        $date: [
          "startDate",
          "endDate",
          function(startDate, endDate) {
            var start = moment(startDate);
            var end = moment(endDate);
            return `${start.format("MMM D")} - ${end.format("MMM D")}`;
          }
        ]
      }
    });
    requests.find.before(function(id, opts = {}) {
      opts.endpoint =
        "/leave/requests/" +
        backend.enterprise.code +
        "/" +
        backend.userdata.email;
      opts.attrs = {
        id: id
      };
      return [id, opts];
    });
    requests.findAll.before(function(params, opts = {}) {
      opts.endpoint =
        "/leave/requests/" +
        backend.enterprise.code +
        "/" +
        backend.userdata.email;
      return [params, opts];
    });

    return {
      Summary: summary,
      Requests: requests,
      getLeave: function() {
        return Promise.all([
          summary.find(backend.userdata.email),
          requests.findAll()
        ]).catch(function(e) {
          console.error(e);
        });
      }
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/leave.js